<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div>
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
              
                <div class="modal-dialog">
                    <div class="modal-body modal-content">                     
                        <div class="">
                            <div class="title_block">
                                <h3 class="mb-0 font-active">
                                    {{ title }}: <span>{{ item.includes('mm') ? item : item + ' mm' }}</span>
                                  </h3>
                                <span @click="notOpenModal">
                                    <SvgHeaderSvg type="close" class="largesvg"/></span>
                            </div>
                            <div class="mt-3">

                                <div class="iamge_block text-center my-3">
                                    <img class="" src="/settingactive/bandwidth.svg">
                                    <p class="title"> {{ item.includes('mm') ? item : item + ' mm' }}</p>
                                </div>
                                <p class="mb-0">The band width refers to the width of the ring’s band. The width typically ranges from 1.7mm to 7mm. Narrow bands appear delicate, while wider bands look bold.
                                </p>
  
                                <!-- Preset and CYO route and type -->
                                <p class="mb-0 text mt-1" v-if="showPresetOrCYOMsg">*The bandwidth varies according to ring size and the center stone weight.</p>
                                
                                <!-- Specific for 5,& 7 Stone -->
                                
                                <p class="mb-0 text mt-1" v-if="showFiveOrSevenStoneMsg">*The bandwidth varies according to ring size.</p>
                                
                                <!-- below for wedding band only -->

                                <p class="mb-0 text mt-1" v-if="showAnniversaryRingMsg">*The bandwidth varies according to ring size and the total carat weight.</p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </Teleport>

    </div>
</div>
</template>

<script setup>
    const flagShowModal = ref(false);
    const bandwidth = ref(null);
  
    const route = useRoute()

    const props = defineProps(['item', 'title','moduleSubType','detailData','type','ringBox' ]);

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);


    const showPresetOrCYOMsg = computed(() => {
        return (
            props.detailData?.sub_type !== 'in-stock-ring' &&
            (route?.meta?.moduleType === 'cyo' || props.type === 'preset') &&
            !['five-stone', 'seven-stone', 'anniversary-ring'].includes(props.detailData?.sub_type_1)
        );
    });

    const showFiveOrSevenStoneMsg = computed(() => {
    return (
        props.detailData?.sub_type !== 'in-stock-ring' && 
        props.type !== 'preset' && 
        !['anniversary-ring'].includes(props.detailData?.sub_type) && 
        ['five-stone', 'seven-stone'].includes(props.detailData?.sub_type_1)
    );
});


    const showAnniversaryRingMsg = computed(() => {
        return props.detailData?.sub_type === 'anniversary-ring' || 'couple-bands-ring' && 
        props.type !== 'preset' && props.detailData?.sub_type !== 'in-stock-ring' && route?.meta?.moduleType !== 'cyo' ;
    });
    // sub_type : "in-stock-ring" 
    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = bandwidth.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        }
        });
    };

    const hideModal = () => {
        const modalElement = bandwidth.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };
</script>



<style scoped>
.text{
    font-size: 14px;
    font-style: italic;
    color: #909090;
}
.largesvg {
    transform: scale(1.3);
    }
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #606060;
}
h3{
    font-size: 22px;
}
.title_block span {
    cursor: pointer;
    color: var(--green);
}
.m-info {
    margin: 10px 0;
}

.title{
    text-transform: capitalize;
    color: #668b84;
    font-size: 16px;
}
@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }
    .text{
        font-size: 12px;
    }

}
</style>
